import React from 'react';
import { Box, Paper, Typography, Avatar } from '@mui/material';
import BadgeWrapper from './BadgeWrapper';
import Badge from '../../../v2/MUI_custom_component/Badge';

const InfoCard = ({title, value}) =>(
  <Box sx={{ display: 'flex', mb: 0.5 }}>
    <Typography variant="p3" sx={{ color: '#666', minWidth: {xs: '120px', sm: '150px'} }}>{title}</Typography>
    <Typography variant="p3" sx={{ color: '#000' }}>{value}</Typography>
  </Box>
)

const InventoryCompanyCard = ({ clickHandler, logo, name, date, unit, availableQty, unverifiedQty, badgeText, actionButton }) => (
  <BadgeWrapper onClick={clickHandler} backgroundColor='#fff'>
    {badgeText ? (
        <Badge
          badgeText={badgeText}
          badgeType="card"
          badgeSize="small"
        />
      ) : null
    }
    <Box sx={{ p: 2, display: 'flex', flexDirection: {xs: 'column', sm: 'row'}, justifyContent: 'space-between', pt: { xs: badgeText ? 2: 1, md:2 }, }}>
      <Box display="flex" gap={{xs:1.5, sm:2}} sx={{
       mt: badgeText ? { xs: 2.5, lg: 0 } : 0 , 
       mb: { xs: 1, sm: 0 } }}>
        <Avatar
          src={logo}
          alt={name}
          variant="rounded"
          sx={{ 
            width: 64, 
            height: 64, 
            border: '1px solid #d9d9d9',
            '& img': {
              objectFit: 'contain',
            },
            p: 0.3 
          }}
        />
        <Box sx={{}}>
          <Typography variant="h3" sx={{ mb: { xs:.5, sm: 1.5} }}>{name}</Typography>
          <InfoCard title="Last Invoice Date" value={date} />
          <InfoCard title="Unit of Measurement" value={unit} />
          <InfoCard title="Available Quantity" value={availableQty} />
          <InfoCard title="Unverified Quantity" value={unverifiedQty} />
        </Box>
      </Box>
      {actionButton && (
        <Box sx={{ display: 'flex', justifyContent:'end', alignSelf: 'end'}} >
          {actionButton}
        </Box>
      )}
    </Box>
  </BadgeWrapper>
);

export default InventoryCompanyCard;
